/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForFirmwareGroupsResponseByDateHour,
    ReportForFirmwareGroupsResponseByDateHourFromJSON,
    ReportForFirmwareGroupsResponseByDateHourFromJSONTyped,
    ReportForFirmwareGroupsResponseByDateHourToJSON,
} from './ReportForFirmwareGroupsResponseByDateHour';

/**
 * 
 * @export
 * @interface ReportForFirmwareGroupsResponse
 */
export interface ReportForFirmwareGroupsResponse {
    /**
     * 
     * @type {{ [key: string]: ReportForFirmwareGroupsResponseByDateHour; }}
     * @memberof ReportForFirmwareGroupsResponse
     */
    byDateHour: { [key: string]: ReportForFirmwareGroupsResponseByDateHour; } | null;
}

export function ReportForFirmwareGroupsResponseFromJSON(json: any): ReportForFirmwareGroupsResponse {
    return ReportForFirmwareGroupsResponseFromJSONTyped(json, false);
}

export function ReportForFirmwareGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForFirmwareGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'byDateHour': (json['byDateHour'] === null ? null : mapValues(json['byDateHour'], ReportForFirmwareGroupsResponseByDateHourFromJSON)),
    };
}

export function ReportForFirmwareGroupsResponseToJSON(value?: ReportForFirmwareGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'byDateHour': (value.byDateHour === null ? null : mapValues(value.byDateHour, ReportForFirmwareGroupsResponseByDateHourToJSON)),
    };
}

